import React, { useState } from 'react';
import styled from 'styled-components';
import { colorTokens } from '../../../../../tokens/globals/tokens';
import Box from '../../../../Box/Box';
import CustomText from '../../../../Typography/CustomText/CustomText';
import HStack from '../../../../HStack/HStack';
import Icon from '../../../../Icon/Icon';
import VStack from '../../../../VStack/VStack';

// Fragments
const SiteKitUtilityGroupContainerButton = styled.button`
  border: none;
  border-top: 1px solid ${colorTokens.GlobalBrandGray30};
  box-sizing: border-box;
  background: transparent;
  cursor: pointer;
  padding: 16px 20px;
  width: 100%;
`;
const SiteKitUtilityCollapsibleGroupHeader = ({ title, open, onClick }) => (
  <SiteKitUtilityGroupContainerButton data-testid="utility-group-expand-button" onClick={onClick}>
    <HStack align="distributed" alignY="center" spacing="none">
      <CustomText whiteSpace="nowrap" size="13" color="gray" weight="medium">
        {title}
      </CustomText>
      <CustomText whiteSpace="nowrap" size="13" color="gray">
        <Icon type={open ? 'up' : 'down'} meaning={open ? 'close' : 'open'} />
      </CustomText>
    </HStack>
  </SiteKitUtilityGroupContainerButton>
);

// Exports
interface SiteKitUtilityGroupCollapsibleProps {
  children: React.ReactNode;
  title: string;
  open?: boolean;
}
const SiteKitUtilityGroupCollapsible = ({
  children,
  title,
  open: initialOpen = false,
}: SiteKitUtilityGroupCollapsibleProps) => {
  const [open, setOpen] = useState(initialOpen);
  return (
    <Box>
      <SiteKitUtilityCollapsibleGroupHeader title={title} open={open} onClick={() => setOpen(prevOpen => !prevOpen)} />
      {open && (
        <Box horizontal="gutter" top="none" bottom="gutter">
          <VStack spacing="xsmall">{children}</VStack>
        </Box>
      )}
    </Box>
  );
};

SiteKitUtilityGroupCollapsible.displayName = 'SiteKit.Sidebar.Utilities.GroupCollapsible';

export { SiteKitUtilityGroupCollapsible, SiteKitUtilityGroupCollapsibleProps };
